/**
 * Learning mode: name every button as it is pressed.
 *
 * The same physical key does different things depending on whether your side has the ball,
 * and three of them do nothing at all while you are defending (`possessionContext` in
 * `player.ts`). The CONTROLS page says so in a list, but a list is read once and a match is
 * played with the hands, so somebody pressing the shot key while defending still gets
 * nothing and still has no idea why. This puts one short line low on the screen saying what
 * the press he just made actually did.
 *
 * On by default: it is the answer to "what do these keys do", and it is one small line. The
 * switch is on the CONTROLS page, which is where somebody looking for that answer already is.
 *
 * Kept here rather than with the other display settings because it is remembered between
 * visits, and the key bindings next door are the only other thing in this game that is.
 */

const STORAGE_KEY = 'gf.learningMode.v1';

let enabled = true;

export function loadLearningMode(): boolean {
  try {
    const stored = globalThis.localStorage?.getItem(STORAGE_KEY);
    if (stored !== null && stored !== undefined) enabled = stored === 'on';
  } catch {
    // Storage can be unavailable; on is a valid answer.
  }
  return enabled;
}

export function learningMode(): boolean {
  return enabled;
}

export function setLearningMode(on: boolean): boolean {
  enabled = on;
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, on ? 'on' : 'off');
  } catch {
    // Not being able to remember it is no reason to refuse it for this session.
  }
  return enabled;
}
